module.exports = __webpack_public_path__ + "img/site.44287f6a.png";